import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.maintenance

export const getMaintenanceActive = createSelector(
  _getState,
  (state) => state.active
)

export const getMaintenanceMessage = createSelector(
  _getState,
  (state) => state.message
)

export const getMaintenanceTitle = createSelector(
  _getState,
  (state) => state.title
)
